import {handleDropAddShapeEvent} from '../logic/logic';
import {elementNameConst, stateConst} from '../../conf';
import {getIdStr} from '../../data';

/**
 * 拓扑插件-自定义添加节点交互事件
 */

export default {
  name: 'custom-add-node',
  options: {
    getEvents() {
      return {
        'custom:editor:addNode': 'onCustomEditorAddNode',
        'custom:editor:copyNode': 'onCustomEditorCopyNode',
        'custom:editor:deleteNode': 'onCustomEditorDeleteNode'
      };
    },
    onCustomEditorAddNode(param) {
      // 转换坐标
      const point = this.graph.getPointByClient(param.evt.clientX, param.evt.clientY);
      param.evt.canvasX = point.x;
      param.evt.canvasY = point.y;
      handleDropAddShapeEvent(param.that, param.evt);
    },
    onCustomEditorCopyNode() {
      // 查询所有选中的元素
      const nodes = this.graph.findAllByState(elementNameConst.node, stateConst.selected);
      nodes?.forEach(item => {
        const nodeModel = item.get('model');
        // 增加坐标偏移量
        const x = nodeModel.x + 10;
        const y = nodeModel.y + 10;

        const dataModel = {
          ... nodeModel,
          id: getIdStr(),
          x,
          y
        };

        const nodeItem = this.graph.addItem(elementNameConst.node, dataModel);
        nodeItem.toFront();
        nodeItem.setState(stateConst.selected, true);
        item.clearStates(stateConst.selected);
      });
    },
    onCustomEditorDeleteNode() {
      // 查询所有选中的元素
      let nodes = this.graph.findAllByState(elementNameConst.node, stateConst.selected);
      const combos = this.graph.findAllByState(elementNameConst.combo, stateConst.selected);
      const edges = this.graph.findAllByState(elementNameConst.edge, stateConst.selected);

      nodes.concat(combos);

      if (nodes.length === 0 && edges.length > 0) {
        nodes = edges;
      }

      if (nodes.length > 0) {
        nodes?.forEach(item => {
          this.graph.removeItem(item);
        });
      }
    }
  }
};
